
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brand-assets",
      function () {
        return require("private-next-pages/brand-assets.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brand-assets"])
      });
    }
  